import React from "react";
import ReactDOM from "react-dom";
import Container from "./containers/session";

export default class extends React.PureComponent {
  render() {
    return <Container {...this.props} />;
  }
}
